export default "__VITE_ASSET__8ebe2a34__"